import {Button} from 'platform/components';
import {Box, Center, Heading, Icon, VStack, Text} from 'platform/foundation';

import i18n from '@dms/i18n';

interface EmptyStateProps {
  onCreateClick: () => void;
  isLoading: boolean;
  isDisabled?: boolean;
}

export function EmptyState(props: EmptyStateProps) {
  return (
    <Box width="100%" backgroundColor="palettes.white.10.100">
      <Center height={150}>
        <VStack align="center" spacing={4}>
          <Icon value="action/build" size={12} color="palettes.blue.60.100" />
          <Heading size={3}>{i18n.t('entity.businessCase.labels.serviceCases')}</Heading>
          <Box maxWidth={130}>
            <Text size="small" align="center">
              {i18n.t('entity.businessCase.labels.serviceCasesEmptyDescription')}
            </Text>
          </Box>
          <Button
            title={i18n.t('entity.businessCase.actions.createServiceCase')}
            variant="primary"
            onClick={props.onCreateClick}
            isLoading={props.isLoading}
            isDisabled={props.isDisabled}
          />
        </VStack>
      </Center>
    </Box>
  );
}
